import { deleteDraft as deleteDraftApi } from 'apps/web_forms/api/api';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ids, ModalTypes, APP_ROUTES } from 'apps/web_forms/utils/constants';
import { setModal, fetchDraftList } from 'apps/web_forms/slices/appSlice';
import Modal from 'apps/web_forms/components/commons/Modal';


export const DeleteDraftModal = ({ extraProps, resetSelectedModal }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { selectedDraftId } = extraProps;

  const deleteDraft = async (id) => {
    try {
      const response = await deleteDraftApi(id);
      if (response.status >= 200 && response.status < 300) {
        dispatch(
          setModal({
            type: ModalTypes.DELETE_SUCCESS_MODAL,
            extraProps: {},
          })
        );
        dispatch(fetchDraftList());
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
      history.push(APP_ROUTES.getErrorPageByCode(500));
    }
    return true;
  };

  return (
    <Modal
      mainMessage={'Are you sure you want to delete this draft?'}
      isOpen={true}
      setIsOpen={resetSelectedModal}
      buttons={[
        {
          id: ids.DraftsIds.DeleteConfirmationButton,
          label: 'Delete draft',
          onClick: () => deleteDraft(selectedDraftId),
          filled: true,
        },
        {
          id: ids.DraftsIds.CancelButton,
          label: 'Cancel',
          onClick: resetSelectedModal,
          filled: false,
        },
      ]}
    />
  );
};
